import { ChargebackStatus } from '../types'

export const CHARGEBACK_STATUSES: ChargebackStatus[] = [
  'Pending',
  'Won',
  'Lost',
]

export const STATUS_ALL = 'All'

export const STATUS_TAG_COLORS: Record<ChargebackStatus, string> = {
  Pending: 'orange',
  Won: 'green',
  Lost: 'red',
}

export const FILTER_CONFIG = {
  id: { type: 'string' as const },
  wallets: { type: 'array' as const },
  period: { type: 'array' as const },
  transactionId: { type: 'string' as const },
  statuses: { type: 'array' as const, default: ['Pending'] },
}
